import { Repository } from "src/firebase/firestore/repository";
import { User } from "../types/user.entity";
import { isEmail, isPhoneNumber } from "src/utils/util";

export class UserRepository extends Repository<User> {
  constructor() {
    super("users"); // Make sure this matches your Firestore collection name
  }

  async find(query: any = {}) {
    const users = await super.find(query);
    return users;
  }

  async getByEmailOrPhoneNumber(identifier: string): Promise<User | null> {
    const term = identifier.trim();

    if (isEmail(term)) {
      return this.findOneByField("email", term);
    }

    if (isPhoneNumber(term)) {
      return this.findOneByField("appProfile.phoneNumber", term);
    }
    return null;
  }

  async getByUnique(identifier: string): Promise<User | null> {
    const term = identifier.trim();

    if (isEmail(term)) {
      return this.findOneByField("email", term);
    }

    if (isPhoneNumber(term)) {
      return this.findOneByField("appProfile.phoneNumber", term);
    }

    // fallback to document-ID lookup
    return this.findById(term);
  }

  private async findOneByField(fieldPath: string, value: string): Promise<User | null> {
    const results = await this.find({
      where: { [fieldPath]: value },
    });
    return results[0] ?? null;
  }
}

export const userRepository = new UserRepository();
